import React, { useEffect, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/big-title.scss';
import Color from '@tool/color';

interface IProps {
  title: string
}
interface IState { }

const BigTitle = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { title } = props;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="big-title-warp">
      <b></b>
      <i></i>
      <span>{title}</span>
      <p></p>
    </section>
  );
};

export default observer(BigTitle);
